import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails, OwnerRequestDTO, TravelsCurrentStatus } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetOwnerTravelsCurrentStatusCommand extends IRequestCommand<
  IGetOwnerTravelCurrentStatusResponse,
  ErrorDetails,
  IGetOwnerTravelCurrentStatusCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/travelsCurrentStatus/carrier/{carrierId}/owner/{ownerId}';

  public override setParameters(parameters: IGetOwnerTravelCurrentStatusCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}', parameters.carrierUserId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{ownerId}', parameters.ownerId.toString()
    );
  }
}

export interface IGetOwnerTravelCurrentStatusCommandParameters extends ICommandParameters {
  carrierUserId: string;
  ownerId: string;
}

export interface IGetOwnerTravelCurrentStatusResponse
  extends ICommandResponse,
  TravelsCurrentStatus {}
